export default __webpack_public_path__ + "static/media/blank-kid-profile.477a0421.png";